import { AppType, BuilderEnvironment, Theme } from '../builder.interface';
import { BaseBuilderEnvs } from './environment.constants';

export const builderEnvironment: BuilderEnvironment = {
  ...BaseBuilderEnvs[AppType.Gdesemena],
  theme: Theme.DEFAULT,
};
